<template>
  <v-col cols="12" class="pt-0" style="overflow: visible;">
    <div style="display: flex; gap: 8px; overflow: visible;">
      <card-with-header
        :title="$tc('label.vlr_planejado', 1)"
        :content="formatMoney(investido)"
        icon="request_page"
        :hint-regra="$t('label.regra_calculo_valor_planejado')"
        :hint-referencia="$t('label.referencia_data_calendario_planejamento')"
      />
      <card-with-header
        :title="$tc('label.valor_pago_liquidado', 1)"
        :content="formatMoney(pago)"
        icon="monetization_on"
        :hint-regra="$t('label.regra_calculo_valor_pago_liquidado')"
        :hint-referencia="$t('label.referencia_data_calendario_planejamento')"
      />
      <card-with-header
        variant="light"
        :title="$tc('label.orcamento_disponivel', 1)"
        :content="formatMoney(vlrDisponivel)"
        icon="account_balance_wallet"
        :hint-regra="$t('label.regra_calculo_orcamento_disponivel')"
        :hint-referencia="$t('label.referencia_data_calendario_planejamento_parcial')"
      />
      <card-with-header
        variant="light"
        :title="$tc('label.saldo_orcamento', 1)"
        :content="formatMoney(vlrSaldo)"
        icon="bar_chart"
        :hint-regra="$t('label.regra_calculo_saldo_orcamento')"
        :hint-referencia="$t('label.referencia_data_calendario_planejamento_parcial')"
      />
    </div>
  </v-col>
</template>

<script>
import CardWithHeader from '@/produto/shared-components/cardinfo/CardWithHeader';
import { getMoney } from '@/produto/common/functions/helpers';
import { buscarCardsAcoes } from '@/produto/common/resources/planejamento/planejamento-acao-listagem';

export default {
  name: 'KpiCards',
  props: {
    filtros: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CardWithHeader,
  },
  data() {
    return {
      pago: 0,
      investido: 0,
      vlrDisponivel: 0,
      vlrSaldo: 0,
    };
  },
  watch: {
    filtros: {
      handler() {
        this.buscarCards();
      },
      deep: true,
    },
  },
  methods: {
    formatMoney(value) {
      return getMoney(value || 0);
    },
    buscarCards() {
      clearTimeout(this.timerCards);
      this.timerCards = setTimeout(() => this.carregarCards(), 300);
    },
    async carregarCards() {
      const params = {
        ...this.filtros,
        id_holding: this.filtros.id_grupo,
        anoFiscal: this.filtros.ano_fiscal,
        id_acao_selecionada: this.filtros.id_acao_selecionada,
      };

      this.pago = 0;
      this.investido = 0;
      this.vlrDisponivel = 0;
      this.vlrSaldo = 0;
      this.$emit('cards', {});

      try {
        const { data } = await buscarCardsAcoes(params, this.$resource);
        const cardData = data?.resposta?.[0];
        if (cardData) {
          this.pago = cardData.pago || 0;
          this.investido = cardData.investido || 0;
          this.vlrDisponivel = cardData.vlr_disponivel || 0;
          this.vlrSaldo = cardData.vlr_saldo || 0;
          this.$emit('cards', cardData);
        }
      } catch (err) {
        if (err?.data?.error) this.$toast(err.data.error);
      }
    },
  },
  mounted() {
    this.buscarCards();
  },
  beforeDestroy() {
    clearTimeout(this.timerCards);
  },
};
</script>
